// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index." + {"440":"7164966ac3a21870a7bb","581":"d4f419c4fb4eeb3f4b5f"}[chunkId] + ".js";
};